import request from '../request'

export const organizationApi = {
  listOrganization (params) {
    return request.get('/v2/admin/organizations', { params: params })
  },
  getOrganization (id) {
    return request.get('/v2/admin/organizations/' + id)
  },
  saveOrganization (data) {
    return request.post('/v2/admin/organizations', data)
  },
  updateOrganization (id, data) {
    return request.put('/v2/admin/organizations/' + id, data)
  },
  deleteOrganization (id) {
    return request.delete('/v2/admin/organizations/' + id)
  },
}

export default organizationApi
